import { useQuery } from "@tanstack/react-query";
import { getNotice } from "../api/notice";
import userStorage from "../utils/userStorage";

const useGetNotice = (
  page: number,
  newCheck?: number | null,
  limit?: number
) => {
  const user = userStorage.get();
  const isAdmin = user?.permission?.auth_notice === "Y";
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      `notice`,
      `page-${page}`,
      `isAdmin-${isAdmin}`,
      `area-${user?.area}`,
      `newCheck-${newCheck}`,
      `limit-${limit}`,
    ],
    queryFn: () =>
      getNotice({
        part: isAdmin ? 0 : 1,
        page,
        isAdmin,
        area: user?.area as string,
        newCheck,
        limit,
      }),
    retry: false,
    enabled: !!user,
    // staleTime: 60 * 500, // 30초
    // cacheTime: 60 * 500, // 30초
    // onSuccess: (data) => {
    //   return data;
    // },
    // onError: (data) => {
    //   // console.log(`공지사항 조회 에러 발생, 사유 : ${data}`);
    //   return data;
    // },
  });

  return { data, isLoading, isSuccess };
};

export default useGetNotice;
